"use strict";

import React from 'react';
import Icon from "./Icon";

const AlertTemplateBasic = ({ message, options, style, close }) => {

    const alertStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
        width: '18rem',
        boxSizing: 'border-box',
        borderRadius: '6px',
    };

    let iconClassName = `icon-${options.type}`;

    return (
        <div style={{ ...alertStyle, ...style }} className="">
            <div className={`panel panel--is-${options.type} panel--has-icon is-marginless`} style={{width: '100%',}}>
                <div className="panel__icon__container"><i className={iconClassName} /></div>
                <div className="panel__content">{message}</div>
                <button onClick={close} className="btn__delete" style={{marginLeft: 'auto',}} />
            </div>
        </div>
    )
};

export default AlertTemplateBasic;
